export default class Telemeter {
  static telemeter = {
    track: async () => {},
    finish: async () => {},
    identify: async () => {},
    log: async () => {},
  };

  static init() {
    // no-op: disable telemetry in MathType/CKEditor integration
  }

  static async finish() {
    return;
  }
}
